import type { Stripe } from 'stripe';
import { type StripeProducts } from './types';

/**
 * these states represents a subscription that is active and every invoice is paid
 */
export const activeSubStatuses: Stripe.Subscription.Status[] = ['active', 'trialing'];

/**
 * these states represent a subscription that is active or at least recoverable by paying the related invoices, or unpause
 */
export const validSubStatuses: Stripe.Subscription.Status[] = [
  'active',
  'trialing',
  'incomplete',
  'past_due',
  'paused',
  'unpaid',
];

/**
 * these states represents a subscription that needs payment
 */
export const needsPaymentSubStatuses: Stripe.Subscription.Status[] = ['incomplete', 'past_due', 'unpaid'];

export function findCurrentCompanySub<R extends Stripe.Subscription>(
  subs: R[],
  stripeProducts: StripeProducts,
  statuses: Stripe.Subscription.Status[] = activeSubStatuses,
): R | undefined {
  return subs
    .filter(sub => statuses.includes(sub.status))
    .find(sub => {
      return sub.items.data.some(i => {
        return (
          i.price.product === stripeProducts.proButler ||
          i.price.product === stripeProducts.pro ||
          i.price.product === stripeProducts.grow ||
          i.price.product === stripeProducts.startup ||
          i.price.product === stripeProducts.shareRegistry
        );
      });
    });
}

export function hasSubscription(sub: Stripe.Subscription | null, productIds: string[]): boolean {
  return productIds.some(prodId => sub?.items.data.map(i => i.price.product as string).includes(prodId));
}
